import React from "react";
import createMuiTheme from "@material-ui/core/styles/createMuiTheme";
import {Grid, Tab, Tabs, ThemeProvider} from "@material-ui/core";
import styled from "styled-components";
import {useAuthState} from "react-firebase-hooks/auth";
import Firebase from "firebase";

interface CalendarHeader {
    page: number;
    onChange: (event: React.ChangeEvent<{}>, newValue: number) => void;
}

const TabsContainer = styled(Tabs)`
  width: 100%;
  position: sticky;
  z-index: 50;
  background-color: #F1F1EE;
  top: 0;
`;

const CalendarHeader = (props: CalendarHeader) => {
    const {page, onChange} = props;
    const [user] = useAuthState(Firebase.auth());

    return (
        <Grid xs={12} item>
            <ThemeProvider theme={theme}>
                <TabsContainer
                    value={page}
                    onChange={onChange}
                    variant={"fullWidth"}
                >
                    <Tab label={"Today"} />
                    <Tab label={"Week"} />
                    <Tab label={"All"} />
                    {user &&
                        <Tab label={"My Events"}/>
                    }
                </TabsContainer>
            </ThemeProvider>
        </Grid>
    );
};

const theme = createMuiTheme({
    overrides: {
        MuiTabs: {
            indicator: {
                backgroundColor: "#A3D032"
            }
        }
    }
});

export default CalendarHeader;